/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-named-as-default */
// eslint-disable-next-line import/no-named-as-default-member
import { ApiPrefixV1, ApiV1Base } from 'util/icwUtility';
import qs from 'qs';
import Request from './request';

export const apiProductQualityRequirements = async ({ action, id, data, qrId }) => {
  let url = `/micro/products/${id}/quality-requirements`;
  let method = '';
  const config = {};
  switch (action) {
    case 'get': {
      const queryString = qs.stringify(data, {
        encodeValuesOnly: false,
        indices: false,
      });
      url = `/micro/products/${id}/quality-requirements?${queryString}`;
      method = 'GET';
      break;
    }
    case 'add':
      method = 'POST';
      config.data = data;
      break;
    case 'edit':
      method = 'PUT';
      config.data = data;
      break;
    case 'delete':
      method = 'DELETE';
      url = `/micro/products/${id}/quality-requirements/${qrId}`;
      config.data = {};
      break;
    default:
      break;
  }
  return Request.call({
    url,
    method,
    ...config,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiUpdateProductQualityRequirementItems = async ({
  action,
  id,
  data,
  qrId,
  itemId,
  subKey,
  subId,
}) => {
  let url = `/micro/products/${id}/quality-requirements/${qrId}/items/${itemId}`;
  let method = '';
  const config = {};
  switch (action) {
    case 'edit':
      method = 'PUT';
      config.data = data;
      break;
    case 'delete':
      method = 'DELETE';
      config.data = {};
      break;
    case 'complete':
      url = `/micro/products/${id}/quality-requirements/${qrId}/items/${itemId}/completed`;
      method = 'POST';
      config.data = data;
      break;
    case 'duplicate':
      url = `/micro/products/${id}/quality-requirements/${qrId}/items/${itemId}/duplicate`;
      method = 'POST';
      config.data = {};
      break;
    case 'edit_sub':
      method = 'PUT';
      config.data = data;
      break;
    case 'delete_sub':
      url = `/micro/products/${id}/quality-requirements/${qrId}/items/${itemId}/compliance-data/${subKey}/${subId}`;
      method = 'DELETE';
      config.data = {};
      break;
    case 'link':
      url = `/micro/products/${id}/quality-requirements/${qrId}/items/${itemId}/compliance-data`;
      method = 'POST';
      config.data = data;
      break;
    default:
      break;
  }
  return Request.call({
    url,
    method,
    ...config,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiExportQualityRequirement = async ({ productId, type }) => {
  const url = `/micro/products/${productId}/quality-requirements/${
    type !== 'pdf' ? 'export-as-word' : 'export-as-pdf'
  }`;
  const method = 'GET';
  return Request.call({
    url,
    method,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
    responseType: 'blob',
  });
};
export const apiGetQualityRequirementOptions = async (params) => {
  return Request.call({
    url: '/micro/quality-requirements/custom-options',
    method: 'GET',
    params,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiGetQualityRequirementTemplates = async (params) => {
  return Request.call({
    url: '/micro/quality-requirements/templates',
    method: 'GET',
    params,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiGetQualityRequirementTemplateDetails = async (id, params) => {
  return Request.call({
    url: `/micro/quality-requirements/templates/${id}`,
    method: 'GET',
    params,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
